module.exports = __webpack_public_path__ + "static/media/login-header.b773173e.jpg";